import {withFormik} from "formik";
import * as yup from "yup"
import httpClient from "../../../services/httpClient";
import {categoriesInVideoProductApi} from "../../../constans/apiUrls";
import InnerAddVideoProductToCategoryForm
    from "../../../components/FormTemplates/video_product/InnerAddVideoProductToCategoryForm";
import {ICategoryVideoProductData} from "../../../contracts/data/category_video_product";


const addVideoProductToCategoryValidationSchema = yup.object().shape({
    videoProductId: yup.number().required("محصول الزامی میباشد").min(1, "محصول الزامی میباشد"),
})

interface IAddVideoProductToCategoryFormProps {
    formType?: string,
    categoryId: number,
    handleChange: (data: ICategoryVideoProductData) => void
}

const AddVideoProductToCategoryForm = withFormik<IAddVideoProductToCategoryFormProps, {videoProductId: number}>({
    mapPropsToValues: props => ({
        videoProductId: 0
    }),
    mapPropsToStatus: props => ({
        formType: props.formType,
    }),
    validationSchema: addVideoProductToCategoryValidationSchema,
    handleSubmit: async (values, formikBag) => {
        await httpClient().post(categoriesInVideoProductApi.videos_products_create, {
            category: formikBag?.props?.categoryId, video_product: values.videoProductId
        })
            .then(response => {
                if(response.status === 201 ){
                    formikBag.setStatus({
                        ...formikBag.props,
                        result: response.data
                    })
                    formikBag.props.handleChange(response?.data?.data)
                }
            })
            .catch(error => formikBag.setStatus({
                ...formikBag.props,
                result: error?.response.data
            }))
    },
    displayName: 'AddVideoProductToCategoryForm'
})(InnerAddVideoProductToCategoryForm)

export default AddVideoProductToCategoryForm